import { render, staticRenderFns } from "./sentmail.vue?vue&type=template&id=e80ec3f4&scoped=true"
import script from "./sentmail.vue?vue&type=script&lang=js"
export * from "./sentmail.vue?vue&type=script&lang=js"
import style0 from "./sentmail.vue?vue&type=style&index=0&id=e80ec3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80ec3f4",
  null
  
)

export default component.exports